/* eslint-disable @typescript-eslint/no-empty-function */
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'


import { environment } from '@se-po/shared-environments'
import { SeFeApiModule } from 'se-fe-api'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'

import { TranslateModule } from '@ngx-translate/core'
import { SeFeCardModule } from 'se-fe-card'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'

import { SharedUiAddChildProfileDocsModule } from '@se-po/shared-ui-add-child-profile'
import { SharedUiAddGuardianDocsModule } from '@se-po/shared-ui-add-guardian'
import { SharedUiAddressDocsModule } from '@se-po/shared-ui-address'
import { SharedUiChildContactInfoDocsModule } from '@se-po/shared-ui-child-contact-info'
import { SharedUiContactInfoDocsModule } from '@se-po/shared-ui-contact-info'
import { SharedUiCountrySelectDocsModule } from '@se-po/shared-ui-country-select'
import { SharedUiDisabilitySelectDocsModule } from '@se-po/shared-ui-disability-select'
import { SharedUiDobSelectDocsModule } from '@se-po/shared-ui-dob-select'
import { SharedUiEditPersonaDocsModule } from '@se-po/shared-ui-edit-persona'
import { SharedUiEmailDocsModule } from '@se-po/shared-ui-email'
import { SharedUiEthnicitySelectDocsModule } from '@se-po/shared-ui-ethnicity-select'
import { SharedUiGenderSelectDocsModule } from '@se-po/shared-ui-gender-select'
import { SharedUiGraduationSelectDocsModule } from '@se-po/shared-ui-graduation-select'
import { SharedUiGuardianInviteInfoDocsModule } from '@se-po/shared-ui-guardian-invite-info'
import { SharedUiHighlightLabelDocsModule } from '@se-po/shared-ui-highlight-label'
import { SharedUiMilitarySelectDocsModule } from '@se-po/shared-ui-military-select'
import { SharedUiNameDocsModule } from '@se-po/shared-ui-name'
import { SharedUiOverviewCardDocsModule } from '@se-po/shared-ui-overview-card'
import { SharedUiParentContactInfoDocsModule } from '@se-po/shared-ui-parent-contact-info'
import { SharedUiPersonaAvatarGroupDocsModule } from '@se-po/shared-ui-persona-avatar-group'
import { SharedUiPersonaChoiceDocsModule } from '@se-po/shared-ui-persona-choice'
import { SharedUiPersonaEligibilityDocsModule } from '@se-po/shared-ui-persona-eligibility'
import { SharedUiPersonaInfoDocsModule } from '@se-po/shared-ui-persona-info'
import { SharedUiPersonaPickerDocsModule } from '@se-po/shared-ui-persona-picker'
import { SharedUiPhoneDocsModule } from '@se-po/shared-ui-phone'
import { SharedUiProfileBarDocsModule } from '@se-po/shared-ui-profile-bar'
import { SharedUiSetupBarDocsModule } from '@se-po/shared-ui-setup-bar'
import { SharedUiStateSelectDocsModule } from '@se-po/shared-ui-state-select'
import { SharedUiSuffixSelectDocsModule } from '@se-po/shared-ui-suffix-select'

import { SharedFeatureAffiliationAccessDocsModule } from '@se-po/shared-feature-affiliation-access'
import { SharedFeatureEditPersonaModalDocsModule } from '@se-po/shared-feature-edit-persona-modal'
import { SharedFeatureHouseholdInviteDocsModule } from '@se-po/shared-feature-household-invite'
import { SharedFeatureHouseholdReviewDocsModule } from '@se-po/shared-feature-household-review'
import { SharedFeatureMembershipListDocsModule } from '@se-po/shared-feature-membership-list'
import { SharedFeatureMergePersonaModalDocsModule } from '@se-po/shared-feature-merge-persona-modal'
import { SharedFeatureOrganizationListDocsModule } from '@se-po/shared-feature-organization-list'
import { SharedFeaturePersonaImageModalDocsModule } from '@se-po/shared-feature-persona-image-modal'
import { SharedFeatureProfileSidePanelModule } from '@se-po/shared-feature-profile-side-panel'
import { SharedFeatureRegistrationListDocsModule } from '@se-po/shared-feature-registration-list'
import { SharedFeatureRemovePersonaModalDocsModule } from '@se-po/shared-feature-remove-persona-modal'
import { SharedFeatureTeamListDocsModule } from '@se-po/shared-feature-team-list'
import { SharedUiHighlightLabelModule } from '@se-po/shared-ui-highlight-label'
import { SharedUiPersonaAvatarModule } from '@se-po/shared-ui-persona-avatar'
import { SharedUiProfileSidePanelDocsModule } from '@se-po/shared-ui-profile-side-panel'
import { SharedUiProfileBarModule } from '@se-po/shared-ui-profile-bar'
import { SeFeDocsCodeModule } from 'se-fe-docs-code'
import { SeFeDocsExampleModule } from 'se-fe-docs-example'
import { PrintElementServiceDocsComponent } from './print-element-service-docs/print-element-service-docs.component'
import { OverviewComponent } from './overview/overview.component'
import { SharedDocsRoutingModule } from './shared-docs-routing.module'
import { SeFeButtonModule } from 'se-fe-button'
import { SeRegistrationUiRegistrationCardDocsModule } from '@se-po/se-registration-ui-registration-card'
import { FeatureProfileSidePanelDocsComponent } from './feature-profile-side-panel-docs/feature-profile-side-panel-docs.component'
import { ProfileSidePanelExampleComponent } from './feature-profile-side-panel-docs/profile-side-panel-example.component'

@NgModule({
  declarations: [
    OverviewComponent,
    PrintElementServiceDocsComponent,
    FeatureProfileSidePanelDocsComponent,
    ProfileSidePanelExampleComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    SeFeApiModule.forRoot({
      domainEnvironments: environment.domainEnvironments,
    }),
    SharedDocsRoutingModule,
    SeFeButtonModule,
    SeFeCardModule,
    SeFeDocsCodeModule,
    SeFeDocsExampleModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeHeaderModule,
    SeFePageModule,
    SharedFeatureAffiliationAccessDocsModule,
    SharedFeatureEditPersonaModalDocsModule,
    SharedFeatureHouseholdReviewDocsModule,
    SharedFeatureHouseholdInviteDocsModule,
    SharedFeatureMembershipListDocsModule,
    SharedFeatureMergePersonaModalDocsModule,
    SharedFeatureOrganizationListDocsModule,
    SharedFeaturePersonaImageModalDocsModule,
    SharedFeatureProfileSidePanelModule,
    SharedFeatureRegistrationListDocsModule,
    SharedFeatureRemovePersonaModalDocsModule,
    SharedFeatureTeamListDocsModule,
    SharedUiHighlightLabelModule,
    SharedUiAddChildProfileDocsModule,
    SharedUiAddGuardianDocsModule,
    SharedUiAddressDocsModule,
    SharedUiChildContactInfoDocsModule,
    SharedUiContactInfoDocsModule,
    SharedUiCountrySelectDocsModule,
    SharedUiDisabilitySelectDocsModule,
    SharedUiDobSelectDocsModule,
    SharedUiEditPersonaDocsModule,
    SharedUiEmailDocsModule,
    SharedUiEthnicitySelectDocsModule,
    SharedUiGenderSelectDocsModule,
    SharedUiGraduationSelectDocsModule,
    SharedUiGuardianInviteInfoDocsModule,
    SharedUiHighlightLabelDocsModule,
    SharedUiMilitarySelectDocsModule,
    SharedUiNameDocsModule,
    SharedUiOverviewCardDocsModule,
    SharedUiParentContactInfoDocsModule,
    SharedUiPersonaAvatarGroupDocsModule,
    SharedUiPersonaChoiceDocsModule,
    SharedUiPersonaEligibilityDocsModule,
    SharedUiPersonaInfoDocsModule,
    SharedUiPersonaPickerDocsModule,
    SharedUiPersonaAvatarModule,
    SharedUiPhoneDocsModule,
    SharedUiProfileBarDocsModule,
    SharedUiProfileBarModule,
    SharedUiProfileSidePanelDocsModule,
    SeRegistrationUiRegistrationCardDocsModule,
    SharedUiSetupBarDocsModule,
    SharedUiStateSelectDocsModule,
    SharedUiSuffixSelectDocsModule,
    TranslateModule.forChild()
  ],
  exports: [OverviewComponent]
})
export class SharedDocsModule {}
